import ServiceLayout from "./ServiceLayout";
import { Typography, Box } from "@mui/material";
import { Helmet } from "react-helmet-async";

const ArtificialLawn = () => {
  return (
    <>
      <Helmet>
        <title>Artificial Lawn | KRM Landscape</title>
        <meta
          name="description"
          content="High-quality artificial lawn solutions by KRM Landscape for homes, offices, and commercial outdoor spaces."
        />
        <meta
          name="keywords"
          content="Artificial Lawn, Synthetic Grass, Lawn Installation, Low Maintenance Lawn, KRM Landscape"
        />
      </Helmet>

      <ServiceLayout title="Artificial Lawn">

        {/* Hero Image */}
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Box
            component="img"
            src="/images/artificiallawn.jpg"
            alt="Artificial Lawn by KRM Landscape"
            sx={{
              width: { xs: "100%", md: "80%" },
              maxHeight: "400px",
              objectFit: "contain",
              borderRadius: "12px",
            }}
          />
        </Box>

        <Typography paragraph>
          Our Artificial Lawn service offers a perfect solution for creating lush,
          green spaces with minimal maintenance. Designed to look natural and feel
          comfortable underfoot, our lawns enhance both indoor and outdoor areas
          without the hassle of regular watering or mowing.
        </Typography>

        <Typography paragraph>
          We use high-quality, UV-resistant artificial grass that retains its color
          and texture over time. Whether for terraces, balconies, gardens, play
          areas, or commercial spaces, our lawns are installed with precision to
          ensure proper drainage, durability, and a seamless finish.
        </Typography>

        <Typography paragraph>
          Our team handles everything from surface preparation and leveling to
          accurate cutting and secure installation. Each project is customized
          based on usage requirements, space layout, and aesthetic preferences.
        </Typography>

        <Typography paragraph>
          With KRM Landscape’s artificial lawn solutions, you enjoy a clean,
          evergreen space throughout the year, saving water, reducing maintenance,
          and enhancing visual appeal effortlessly.
        </Typography>

      </ServiceLayout>
    </>
  );
};

export default ArtificialLawn;
